import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

const userTestimonials = [
  {
    avatar: <Avatar
      alt="Priya Sharma"
    // src="/static/images/avatar/1.jpg"
    />,
    name: 'Priya Sharma',
    occupation: 'HR Manager',
    testimonial:
      'TalentRealm reduced our screening time by more than 50%. The AI match scores are spot on, helping us quickly identify the best-fit candidates.',
  },
  {
    avatar: <Avatar
      alt="Rahul Mehta"
      // src="/static/images/avatar/2.jpg"
    />,
    name: 'Rahul Mehta',
    occupation: 'Software Engineer',
    testimonial:
      'Uploading my resume and seeing match percentages instantly gave me confidence. I landed interviews much faster than before.',
  },
  {
    avatar: <Avatar
      alt="Emily Carter"
      // src="/static/images/avatar/3.jpg"
    />,
    name: 'Emily Carter',
    occupation: 'Recruiter',
    testimonial:
      'The resume parser + JD builder combo is a game-changer. Our HR team now spends more time interviewing and less time sorting resumes.',
  },
  {
    avatar: <Avatar
      alt="Daniel Wolf"
      // src="/static/images/avatar/4.jpg"
    />,
    name: 'Daniel Wolf',
    occupation: 'CDO',
    testimonial:
      'We were impressed by the security and scalability of TalentRealm. It integrates seamlessly into our workflow and ensures data privacy.',
  },
  {
    avatar: <Avatar
      alt="Ananya Patel"
      // src="/static/images/avatar/5.jpg"
    />,
    name: 'Ananya Patel',
    occupation: 'Graduate Student',
    testimonial:
      'As a fresher, TalentRealm helped me tailor my resume and understand which jobs I was the best fit for. A huge confidence booster!',
  },
  {
    avatar: <Avatar
      alt="John Smith"
      // src="/static/images/avatar/6.jpg"
    />,
    name: 'John Smith',
    occupation: 'Talent Acquisition Lead',
    testimonial:
      'The real-time scoring and analytics are incredibly powerful. We can now prioritize candidates based on actual skill-job fit rather than guesswork.',
  },
];

export default function Testimonials() {
  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        <Typography component="h2" variant="h4" gutterBottom sx={{ color: 'text.primary' }}>
          Success stories
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Recruiters and candidates trust TalentRealm to make smarter hiring decisions.
          Here’s how we’re helping people find the perfect fit.
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} sx={{ display: 'flex' }}>
            <Card
              variant="outlined"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flexGrow: 1,
                p: 2,
              }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ color: 'text.secondary' }}
                >
                  “{testimonial.testimonial}”
                </Typography>
              </CardContent>
              <CardHeader
                avatar={testimonial.avatar}
                title={testimonial.name}
                subheader={testimonial.occupation}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
